import React from 'react';
import {
  Typography,
  Card,
  CardTitle,
  CardBody,
  CardActions,
  Button,
  ButtonGroup,
} from '@one-thd/sui-atomic-components';
import { IAddress } from '../../models/address';

interface IInstantCheckoutAddressCard {
  onEdit: () => void;
  onChangeAddress: () => void;
  disabled: boolean;
  address: IAddress | undefined;
}

export const InstantCheckoutAddressCard = ({
  onEdit,
  onChangeAddress,
  disabled,
  address,
}: IInstantCheckoutAddressCard) => {
  const cardTitle = `${address?.name?.firstName} ${address?.name?.lastName}`;
  const textColor = disabled ? 'inactive' : 'primary';
  return (
    <Card
      className="sui-block sui-col-span-12 md:sui-col-span-4 2xl:sui-col-span-3"
      data-testid="checkout-address-card"
    >
      <CardTitle
        header={
          <Typography variant="h3" color={textColor} data-qm-mask="">
            {cardTitle}
          </Typography>
        }
      />
      {address?.postalAddress && (
        <CardBody>
          <Typography color={textColor} data-qm-mask="">
            {address?.postalAddress.addressLine1}
          </Typography>
          {address?.postalAddress.addressLine2 && (
            <Typography color={textColor} data-qm-mask="">
              {address?.postalAddress.addressLine2}
            </Typography>
          )}
          <Typography
            color={textColor}
            data-qm-mask=""
          >{`${address?.postalAddress.city}, ${address?.postalAddress.stateProvince} ${address?.postalAddress.zipCode}`}</Typography>
        </CardBody>
      )}
      <CardActions>
        <ButtonGroup
          disabled={disabled}
          orientation="vertical"
          variant="secondary"
        >
          <Button data-testid="checkout-btn-edit" onClick={onEdit}>
            Edit Delivery Details
          </Button>
          <Button data-testid="checkout-btn-change" onClick={onChangeAddress}>
            Change Where You Get It
          </Button>
        </ButtonGroup>
      </CardActions>
    </Card>
  );
};
